import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { FontAwesomeLayers } from "@fortawesome/vue-fontawesome";

// import and add all light size font-awesome icons
import { fal } from '@fortawesome/pro-light-svg-icons';
library.add(fal);

// import and add only those specific icons for a Solid type
import { faRetweet, faThumbtack, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faExclamationTriangle, faHeart, faQuestionSquare, faClipboardListCheck, faComment, faCommentPlus, faQuestion, faCheckCircle, faChartBar, faPlay, faPause, faStop, faRepeat, faFilePdf, faFileExcel, faLineColumns, faColumns} from '@fortawesome/pro-solid-svg-icons';
library.add(faRetweet);
library.add(faThumbtack);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faChevronDown);
library.add(faExclamationTriangle);
library.add(faHeart);
library.add(faQuestionSquare);
library.add(faClipboardListCheck);
library.add(faComment);
library.add(faCommentPlus);
library.add(faQuestion);
library.add(faCheckCircle);
library.add(faChartBar);
library.add(faPlay);
library.add(faPause);
library.add(faStop);
library.add(faRepeat);
library.add(faFilePdf);
library.add(faFileExcel);
library.add(faLineColumns);
library.add(faColumns);


// import duo tone icons
import { faTimesCircle as fadTimesCircle } from '@fortawesome/pro-duotone-svg-icons';

library.add(fadTimesCircle);

// make the list available for searching in icon picker dropdown
window.falib = Object.keys(library.definitions.fal);

export default {
	install: function (Vue) {
		Vue.component('font-awesome-icon', FontAwesomeIcon);
		Vue.component('font-awesome-layers', FontAwesomeLayers);
	}
};
